import { REQUIRED_FIELD, max_string_msg } from '@forms/messages'
import * as Yup from 'yup'

// ==================== BASE ATTACHMENT TYPES ====================

export type AttachmentType =
  | 'Asset'
  | 'Service'
  | 'Task/Activity'
  | 'Insurance'
  | 'Maintenance'
  | 'Vendor'

export interface Attachment {
  ID: string
  Comment: string
  FileName: string
  Type: AttachmentType
}

// ==================== STAGED ATTACHMENTS ====================

export interface StagedAttachment {
  id: string // temporary ID for staging
  file: File
  comment: string
}

// ==================== API PAYLOAD INTERFACES ====================

export interface UploadAttachmentPayload {
  file: any
  assetCompanyID: number
  objectIDs: string[]
  type: AttachmentType
  comment: string
}

export interface GetAssetAttachmentsPayload {
  assetCompanyID: number
  assetID: string
}

export interface DeleteAttachmentPayload {
  id: string
  type: AttachmentType
}

export interface EditAttachmentPayload {
  ID: string
  Comment: string
  Type: string
}

// ==================== FORM SUBMISSION DATA ====================

export interface InsuranceFormSubmissionData {
  insuranceData: any
  stagedAttachments: StagedAttachment[]
}

export interface MaintenanceFormSubmissionData {
  maintenanceData: any
  stagedAttachments: StagedAttachment[]
}

export interface VendorFormSubmissionData {
  vendorData: any
  stagedAttachments: StagedAttachment[]
}

// ==================== VALIDATION SCHEMAS ====================

export const addAttachmentSchema = Yup.object({
  comment: Yup.string().required(REQUIRED_FIELD).max(50, max_string_msg(50)),
})

export const editAttachmentSchema = Yup.object({
  Comment: Yup.string().required(REQUIRED_FIELD).max(50, max_string_msg(50)),
  Type: Yup.string().required(REQUIRED_FIELD),
})
